import { trpc } from '@/shared/api/trpc';

// Wraps `itineraries.updateChapters`. Returns the BE response
// (`{ id, chapters, cascadeItemCount }`) so the caller can surface a
// "travellers cascaded to N items" message. Invalidates `byId` by
// `{ id }` only so the planner's `includeSubitems:true` cache AND
// the settings page's `includeSubitems:false` cache both refresh.
// Also invalidates `itineraryPricing.budget` — the chapter cascade
// rewrites `item.travellers`, and PAX-priced items recompute totals
// off that field; without this invalidation the day-list totals
// stay stuck on the pre-cascade pax count. Toasts live at the call
// site per the architecture doc.
export const useUpdateChapters = (args: { itineraryId: string | null }) => {
  const utils = trpc.useUtils();
  return trpc.itineraries.updateChapters.useMutation({
    onSettled: () => {
      if (args.itineraryId) {
        utils.itineraries.byId.invalidate({ id: args.itineraryId });
        utils.itineraryPricing.budget.invalidate();
      }
    },
  });
};
